<div
  class="table-container mt-0 max-h-[calc(90vh-170px)] overflow-y-auto border border-[#ddd]"
>
  <table class="table-fixed w-full table-striped">
    <thead class="h-[50px] w-full sticky top-0 bg-[#1A4971] z-20">
      <tr class="bg-muted text-muted-foreground text-[#343A40] bg-[#DEE2E6]">
        <th class="p-2 pl-[2rem] !font-Roboto !text-left">Addendum Title</th>
        <th class="p-2 !font-Roboto !text-left">Date Created</th>
        <th class="p-2 !text-left">Status</th>
        <th class="p-2">Action</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="addendums && addendums?.length > 0">
        <tr
          *ngFor="let addendum of addendums; let i = index"
          class="hover:bg-muted/50 font-bold !font-Roboto !cursor-default"
        >
          <td class="border-b p-2 pl-[2rem] !text-left cursor-pointer">
            {{ addendum?.title }}
          </td>
          <td class="border-b p-2 !text-left">
            {{ addendum?.created_at | date : "d/M/y" }}
          </td>
          <td class="border-b p-2 !text-left">
            <app-status-badge
              [status]="addendum?.addendum_status"
            ></app-status-badge>
          </td>
          <td class="border-b p-2 text-center">
            <button mat-button [matMenuTriggerFor]="menu">
              <img
                src="assets/icons/action_icon.svg"
                alt="action icon"
                class=""
              />
            </button>
            <mat-menu #menu="matMenu">
							<button mat-menu-item>
                <mat-icon style="color: #2196f3">edit</mat-icon>
                <span>Update Status</span>
              </button>
              <!-- <button mat-menu-item>
                <mat-icon style="color: #2196f3">edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item>
                <mat-icon style="color: #f44336">delete</mat-icon>
                <span>Delete</span>
              </button>
              <button mat-menu-item>
                <mat-icon style="color: #4caf50">visibility</mat-icon>
                <span>View Details</span>
              </button> -->
            </mat-menu>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
